import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen items-center justify-center bg-brand-50" }
const _hoisted_2 = { class: "min-h-screen w-full max-w-full space-y-6 rounded-md border border-gray-200 bg-white p-6 sm:min-h-[unset] sm:w-[535px]" }

import LoginForm from '../components/LoginForm.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-900" }, "Zaloguj się", -1)),
      _createVNode(LoginForm)
    ])
  ]))
}
}

})